// @ts-check

import ResetGridLink from '~/components/Shared/DataGrid/ResetGridLink';
import { EventNames } from '~/components/Tasks/TaskDataGrid/TaskDataGrid.utils';
import { useTaskDataGridContext } from '~/components/Tasks/TaskDataGrid/TaskDataGrid.context';

export default function ResetTaskGridLink() {
    const { settings } = useTaskDataGridContext();

    return (
        <ResetGridLink
            settings={settings}
            resetTableEventName={EventNames.RESET_TABLE}
            defaultSortModel={null}            
        />
    );
}
